import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const headerRowCss = "hinhuak";
export const HeaderRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerRowCss, props.className)} />;
});
const headerColumnIsPhoneCss = "h2jncj3";
const headerColumnCss = "hojvp8m";
export const HeaderColumn = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(headerColumnCss, {
    [headerColumnIsPhoneCss]: isPhone
  }, props.className)} />;
});
const thinHeaderColumnIsPhoneCss = "t1on4e57";
const thinHeaderColumnCss = "t1jbqlvl";
export const ThinHeaderColumn = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <HeaderColumn ref={ref} {...props} className={classNames(thinHeaderColumnCss, {
    [thinHeaderColumnIsPhoneCss]: isPhone
  }, props.className)} />;
});
const containerIsTabletUpCss = "c1q4s6kp";
const containerCss = "c724fi7";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});

require("./list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./list.js");